module.exports = __webpack_public_path__ + "static/img/ycc-wx.1ba421ab.png";